/**
 * journeyText.js — Nettoyage d'affichage uniquement.
 *
 * Objectif : masquer dans le rendu public les marqueurs techniques ajoutés
 * par le script historique `backend/services/v13_6_journey_migration.py`
 * (séparateurs "─── Anciens blocs consolidés (V13.6) ───" et étiquette
 * "À propos (bio longue) :"), SANS toucher à la donnée en base.
 *
 * Comportement :
 *   - supprime la ligne de titre « Anciens blocs consolidés (V13.6) »
 *     (avec ou sans tirets typographiques autour) ;
 *   - supprime la ligne de clôture typographique
 *     (une suite de caractères "─" seule sur sa ligne) ;
 *   - remplace l'étiquette "À propos (bio longue) :" par "À propos :"
 *     pour conserver le libellé lisible sans l'indicateur de champ interne ;
 *   - compacte les lignes vides consécutives qui résulteraient du retrait.
 *
 * Important :
 *   - ne modifie pas le reste du contenu (Titres mis en avant,
 *     Faits marquants, Statut sportif proposé, texte libre) ;
 *   - n'écrit rien côté serveur ;
 *   - n'est utilisé que pour l'affichage public, pas pour l'édition.
 */

const MARKER_LINE_START = /^[\s─—-]*Anciens blocs consolidés \(V13\.6\)[\s─—-]*$/;
const MARKER_LINE_SEP = /^[\s─—-]{3,}$/;
const BIO_LONG_LABEL = /^À propos \(bio longue\)\s*:\s*$/;

/**
 * Nettoie le texte de parcours pour l'affichage public.
 * @param {string | null | undefined} raw
 * @returns {string}
 */
export function cleanJourneyForDisplay(raw) {
  if (!raw || typeof raw !== "string") return "";

  const lines = raw.split("\n");
  const out = [];
  for (const line of lines) {
    const trimmed = line.trim();
    if (MARKER_LINE_START.test(trimmed)) continue;
    if (MARKER_LINE_SEP.test(trimmed)) continue;
    if (BIO_LONG_LABEL.test(trimmed)) {
      out.push("À propos :");
      continue;
    }
    out.push(line);
  }

  // Compacter les enchaînements de lignes vides (3+ -> 2 max).
  const compacted = [];
  let emptyRun = 0;
  for (const line of out) {
    if (line.trim() === "") {
      emptyRun += 1;
      if (emptyRun <= 2) compacted.push(line);
    } else {
      emptyRun = 0;
      compacted.push(line);
    }
  }

  // Enlever les lignes vides en tête et en queue.
  while (compacted.length && compacted[0].trim() === "") compacted.shift();
  while (compacted.length && compacted[compacted.length - 1].trim() === "") compacted.pop();

  return compacted.join("\n");
}
